module.exports = __webpack_public_path__ + "static/media/Coldiac-Italic.da7d0986.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Coldiac-Italic.otf
// module id = 2925
// module chunks = 51